"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.siftIcons = exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _TrendingDown = _interopRequireDefault(require("@material-ui/icons/TrendingDown"));
var _Restaurant = _interopRequireDefault(require("@material-ui/icons/Restaurant"));
var _LocalActivity = _interopRequireDefault(require("@material-ui/icons/LocalActivity"));
var _Receipt = _interopRequireDefault(require("@material-ui/icons/Receipt"));
var _AttachMoney = _interopRequireDefault(require("@material-ui/icons/AttachMoney"));
var _LocalShipping = _interopRequireDefault(require("@material-ui/icons/LocalShipping"));
var _Flight = _interopRequireDefault(require("@material-ui/icons/Flight"));
var _DirectionsRailway = _interopRequireDefault(require("@material-ui/icons/DirectionsRailway"));
var _DirectionsCar = _interopRequireDefault(require("@material-ui/icons/DirectionsCar"));
var _LocalHotel = _interopRequireDefault(require("@material-ui/icons/LocalHotel"));
var _DirectionsBoat = _interopRequireDefault(require("@material-ui/icons/DirectionsBoat"));
var _Chip = _interopRequireDefault(require("../Chip"));
var _constants = require("./constants");
var _excluded = ["type", "title", "subtitle"];
var _siftIcons;
var siftIcons = exports.siftIcons = (_siftIcons = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_siftIcons, _constants.siftTypes.priceAlert, /*#__PURE__*/_react["default"].createElement(_TrendingDown["default"], null)), _constants.siftTypes.restaurant, /*#__PURE__*/_react["default"].createElement(_Restaurant["default"], null)), _constants.siftTypes.event, /*#__PURE__*/_react["default"].createElement(_LocalActivity["default"], null)), _constants.siftTypes.purchase, /*#__PURE__*/_react["default"].createElement(_Receipt["default"], null)), _constants.siftTypes.bill, /*#__PURE__*/_react["default"].createElement(_AttachMoney["default"], null)), _constants.siftTypes.shipment, /*#__PURE__*/_react["default"].createElement(_LocalShipping["default"], null)), _constants.siftTypes.flight, /*#__PURE__*/_react["default"].createElement(_Flight["default"], null)), _constants.siftTypes.train, /*#__PURE__*/_react["default"].createElement(_DirectionsRailway["default"], null)), _constants.siftTypes.rentalcar, /*#__PURE__*/_react["default"].createElement(_DirectionsCar["default"], null)), _constants.siftTypes.hotel, /*#__PURE__*/_react["default"].createElement(_LocalHotel["default"], null)), (0, _defineProperty2["default"])(_siftIcons, _constants.siftTypes.cruise, /*#__PURE__*/_react["default"].createElement(_DirectionsBoat["default"], null)));
var SiftChip = function SiftChip(_ref, ref) {
  var type = _ref.type,
    title = _ref.title,
    subtitle = _ref.subtitle,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var icon = siftIcons[type];
  return /*#__PURE__*/_react["default"].createElement(_Chip["default"], (0, _extends2["default"])({
    thumbnail: icon,
    ref: ref
  }, rest), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs",
    style: {
      width: 120
    }
  }, /*#__PURE__*/_react["default"].createElement("p", {
    className: "font-bold truncate"
  }, title), /*#__PURE__*/_react["default"].createElement("p", {
    className: "truncate",
    style: {
      fontSize: '0.6rem'
    }
  }, subtitle)));
};
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(SiftChip);
//# sourceMappingURL=Chip.js.map